import {
  Component,
  OnChanges,
  OnInit,
  Input,
  SimpleChanges,
  inject,
} from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { EnvironmentService } from '../../../services/environment.service';
import { DashboardService } from './../../dashboard.service';
import { DateHandlingService } from '../../../services/date-handling.service';
import { NgxLoadingModule } from 'ngx-loading';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-top-5-summary',
  templateUrl: './top5Summary.component.html',
  styleUrls: ['./top5Summary.component.scss'],
  imports: [NgxLoadingModule, MatButtonModule, MatIconModule, MatTooltipModule],
})
export class Top5SummaryComponent implements OnInit, OnChanges {
  private dateService = inject(DateHandlingService);
  private dbs = inject(DashboardService);
  private ss = inject(SessionStorageService);
  private router = inject(Router);
  private envSvc = inject(EnvironmentService);
  private location = inject(Location);

  @Input() solutionId;
  @Input() start;
  @Input() end;
  @Input() selectedUnit;
  @Input() showCasesRan;
  @Input() showClassesChanged;
  private environment;

  app = this.ss.get('currentApp');
  gridData = { Headers: [], Data: null };
  solution;
  rights = [];
  casesRan = [];
  classesChanged = [];
  loading = false;

  ngOnInit() {
    this.environment = this.envSvc.get();
    this.rights = this.ss.get('rights');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.solutionId && changes.solutionId.previousValue !== undefined) ||
      (changes.end && changes.end.previousValue === null) ||
      changes.selectedUnit
    ) {
      this.getTop5();
    }
  }

  dateChange() {
    this.getTop5();
  }

  getTop5() {
    this.loading = true;

    this.dbs
      .getCaseStatsTop(
        this.selectedUnit,
        this.solutionId,
        this.dateService.toUseableIso(this.start, 'start'),
        this.dateService.toUseableIso(this.end, 'end')
      )
      .subscribe(resp => {
        this.loading = false;
        // this.casesRan = resp.results.MostCases;
        this.classesChanged = resp.results.ScoreClassChanges;
      });
  }

  viewUser(ev, id) {
    if (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    this.router.navigate(['/case-explorer', { user: id.id }]);
  }

  viewCase(ev, data) {
    const { ProfileID, Solution } = data;
    const solution = Solution.toLowerCase();

    if (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }

    if (
      this.ss.get('globals')?.['GlobalsGroup']?.['UnitInfo']?.[
        'TurnOffSummaryPage'
      ]
    ) {
      if (solution === 'li') {
        window.open(
          `${this.location.prepareExternalUrl(
            ''
          )}case/${solution}/${ProfileID}/validate`,
          '_blank'
        );
      }
      window.open(
        `${this.location.prepareExternalUrl(
          ''
        )}case/${solution}/${ProfileID}/results`,
        '_blank'
      );
    } else {
      window.open(
        `${this.location.prepareExternalUrl('')}case/summary/${ProfileID}`,
        '_blank'
      );
    }
  }

  viewHistory(ev, data) {
    if (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }

    window.open(
      `${this.environment.basePath}profile-history/${data.Solution}/${data.ProfileID}`,
      '_blank'
    );
  }
}
